import React, { useEffect, useRef, useState } from "react";
import Seo from "../components/Seo";

const accessKey = (process.env.REACT_APP_WEB3FORMS_ACCESS_KEY || "").trim();

const EmailSupport = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [status, setStatus] = useState(null);
  const [sending, setSending] = useState(false);
  const messageRef = useRef(null);

  useEffect(() => {
    const el = messageRef.current;
    if (!el) return;
    el.style.height = "auto";
    el.style.height = `${Math.min(el.scrollHeight, 320)}px`;
  }, [message]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!accessKey) {
      setStatus("Support form is not configured. Set REACT_APP_WEB3FORMS_ACCESS_KEY in .env");
      return;
    }
    setSending(true);
    setStatus(null);

    const formData = new FormData();
    formData.append("access_key", accessKey);
    formData.append("name", name.trim() || "Guest");
    formData.append("email", email.trim());
    formData.append("message", message.trim());
    formData.append("subject", `Support request from ${name.trim() || "Guest"}`);

    try {
      const response = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        body: formData
      });
      const data = await response.json();

      if (data.success) {
        setStatus("success");
        setName("");
        setEmail("");
        setMessage("");
      } else {
        setStatus(data.message || "Send failed. Please try again.");
      }
    } catch (err) {
      setStatus(err.message || "Network error. Please try again.");
    } finally {
      setSending(false);
    }
  };

  return (
    <main className="page legal-page">
      <Seo
        title="Email Support"
        description="Contact OctoGames support by email for account, technical, and gameplay assistance."
        path="/support/email"
        keywords="octogames support, email support, game support contact"
      />
      <div className="container legal-container">
        <section className="support-layout">
          <article className="legal-card support-form-card">
            <h1 className="legal-title">Email Support</h1>
            <p className="legal-intro">
              Contact our support team and we will guide you through account, gameplay, or
              platform issues.
            </p>
            <form className="legal-form" onSubmit={handleSubmit}>
              <label className="legal-label">
                Name
                <input
                  type="text"
                  className="legal-input"
                  placeholder="Your name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  required
                />
              </label>
              <label className="legal-label">
                Email
                <input
                  type="email"
                  className="legal-input"
                  placeholder="your@email.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </label>
              <label className="legal-label">
                Message
                <textarea
                  ref={messageRef}
                  className="legal-input legal-textarea"
                  placeholder="How can we help you?"
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  rows={3}
                  required
                />
              </label>
              {status === "success" && (
                <p className="legal-form-success">Message sent. We&apos;ll get back to you soon.</p>
              )}
              {status && status !== "success" && (
                <p className="legal-form-error">{status}</p>
              )}
              <button type="submit" className="legal-send-btn" disabled={sending}>
                {sending ? "Sending…" : "Send"}
              </button>
            </form>
          </article>

          <article className="legal-card support-info-card">
            <h2 className="legal-section-title">What we can help with</h2>
            <ul className="legal-list">
              <li>Account access, sign-in, and profile sync issues.</li>
              <li>Gameplay problems, loading failures, and broken links.</li>
              <li>General product questions and user guidance.</li>
            </ul>

            <h2 className="legal-section-title">Support SLA</h2>
            <ul className="legal-list">
              <li>First response target: within 24 hours on business days.</li>
              <li>Resolution target for standard requests: 1-3 business days.</li>
              <li>Complex issues may require additional investigation time.</li>
            </ul>

            <h2 className="legal-section-title">Before you send</h2>
            <ul className="legal-list">
              <li>Your browser and device model.</li>
              <li>Game name or exact page URL.</li>
              <li>Clear steps to reproduce the issue.</li>
            </ul>

            <p className="legal-note">
              Tip: you can still email us directly at{" "}
              <a href="mailto:support@octogames.io">support@octogames.io</a>.
            </p>
          </article>
        </section>
      </div>
    </main>
  );
};

export default EmailSupport;
